import { User } from "./user";

export class EntryLine {
    id:number = 0;
    entry_id:number = 0;
    article_id:number = 0;
    article_name:string = '';
    description:string = '';
    quantity:number = 0;
    unit_price:number = 0;
    iva:number = 0.16;
    unity_id:number = null;
    status:string = 'Creada';
    warehouse_id:number = null;
    warehouse_name:string = null;
    selected:boolean = false;
    purchase_order_line_id:number = null;
    purchase_order_id:number = null;
    customer_id:number = 0;
    customer_name:string = '';
    measure_unit:string = 'pza';
    discount:number = 0;
    invoice:string = '';
    warehouse_measure_unit:string = '';
    warehouse_factor:number = 1;
    authorized:boolean = false;
    deliver_to:string = "";
    output_date:Date = new Date();
    warehouse_user_id:number = 0;
    warehouse_user:User = null;
    deliver:boolean = false;
    remission:string = "";
    edit:boolean = false;
}
